import styled from 'styled-components'

export const CollapsableMenusContainer = styled.main`
  display: flex;
  flex-direction: column;

  width: 100%;
`
